import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IShoppingCart {
  id: string;
  img: string;
  title: string;
  price: number;
  quantity: number;
  color: string;
  size: string;
  provider: string;
  skuId: string;
  properties: string[];
}

interface IReducer {
  carts: IShoppingCart[];
}

export const initialState: IReducer = {
  carts: [],
};

const ShoppingCartSlice = createSlice({
  name: 'ShoppingCart',
  initialState,
  reducers: {
    createCart: (state, action: PayloadAction<IShoppingCart[]>) => {
      state.carts = [...action.payload];
    },
    addToCart: (state, action: PayloadAction<IShoppingCart>) => {
      const existProductIndex = state.carts.findIndex(
        (cart) =>
          cart.id === action.payload.id &&
          JSON.stringify(cart.properties) ===
            JSON.stringify(action.payload.properties)
      );
      if (existProductIndex !== -1) {
        state.carts[existProductIndex].quantity += action.payload.quantity;
      } else {
        state.carts.push(action.payload);
      }
    },
    removeFromCart: (
      state,
      action: PayloadAction<{ id: string; properties: string[] }>
    ) => {
      state.carts = state.carts.filter(
        (cart) =>
          cart.id !== action.payload.id ||
          (cart.id === action.payload.id &&
            JSON.stringify(cart.properties) !==
              JSON.stringify(action.payload.properties))
      );
    },
  },
});

export const { createCart, addToCart, removeFromCart } =
  ShoppingCartSlice.actions;

export default ShoppingCartSlice.reducer;
